import React from 'react'
import 'simplebar/dist/simplebar.min.css';
import { IStoreResponse } from '../../../interfaces/store';

interface IProps
{
    items: IStoreResponse[];
    infoMessage: string;
    setRef: (ref: HTMLDivElement | null) => void;
}

export default function StoreList(props: IProps)
{
    return (
        <div ref={ref => props.setRef(ref)} className="list">
            <p className="p-text first-title">
                {props.infoMessage}
            </p>
            {
                props.items.map((i, index) =>
                    <div className="list__item" key={index}>
                        <h2>
                            {i.tradeName}
                        </h2>
                        <p className="p-text">
                            {i.addressLine + " - " + i.addressNeighborhood + " - "  + i.addressCityName +" - " + i.addressStateCode}
                        </p>
                    </div>)
            }
        </div>
    );
}